import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Skeleton,
    TableContainer,
    FormControl,
    Select,
    MenuItem,
} from '@mui/material';
const projects = [
    {
        name: 'Vansh Saini',
        schedule: {
            name: 'After 4 hrs per week',
            type: '1 x members pay rate',
        },
        memberImgList: [
            '/assets/images/img1.png',
            '/assets/images/img2.png',
            '/assets/images/img3.png',
            '/assets/images/img1.png',
        ],
        statusBtn: 'Pending',
        startDate: 'Starts on: Mon, Feb 3, 2025',
        options: [
            'Edit policies',
            'Edit members',
            'Remove',
        ]
    },
    {
        name: 'Tea Break Time',
        schedule: {
            name: 'After 3 hrs per week',
            type: '1 x members pay rate',
        },
        memberImgList: [
            '/assets/images/img1.png',
            '/assets/images/img2.png',
            '/assets/images/img3.png',
            '/assets/images/img1.png',
        ],
        statusBtn: 'Active',
        startDate: 'Starts on: Mon, June 5, 2025',
        options: [
            'Edit policies',
            'Edit members',
            'Remove',
        ]
    },
    {
        name: 'Tea Break Over',
        schedule: {
            name: 'After 3 hrs per week',
            type: '1 x members pay rate',
        },
        memberImgList: [
            '/assets/images/img1.png',
            '/assets/images/img2.png',
            '/assets/images/img3.png',
            '/assets/images/img1.png',
        ],
        statusBtn: 'Pending',
        startDate: 'Starts on: Mon, June 5, 2025',
        options: [
            'Edit policies',
            'Edit members',
            'Remove',
        ]
    },
   
]

const statusCodes = (status) => {
    let bgColor = '';
    switch (status) {
        case 'Pending':
            bgColor = '#F39C12'
            break;
        case 'Active':
            bgColor = '#00C234'
            break;
        default:
            bgColor = 'grey'
            break;
    }
    return bgColor
};

const CustomCheckbox = ({ checked, onChange }) => (
    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);

const Data = () => {
    const [dropdownOptions, setDropdownOptions] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };

    return (
        <div>
            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', }}>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: '#DFDFDF',
                            '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                            '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                        }}>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px' }} padding="checkbox">
                                <CustomCheckbox
                                    checked={projects.length > 0 && selectedValues.length === projects.length}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>#</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Policy Name</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Summary</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}> Members</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}> Accrual schedule</TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>

                        {loading

                            ? [...Array(4)].map((_, i) => (

                                <TableRow key={i}>
                                    {[...Array(6)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))

                            : projects.map((project, index) => (

                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={selectedValues.includes(project.name)}
                                            onChange={() => handleCheckboxChange(project.name)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px', fontFamily: 'Manrope' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Box>
                                                <Typography sx={{ fontSize: '14px', color: '#1760EC', fontWeight: '500', fontFamily: 'Manrope' }}>
                                                    {project.name}
                                                </Typography>

                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box>
                                            <Typography sx={{ color: '#373737', fontSize: '15px', fontWeight: '700', fontFamily: 'Manrope' }}>
                                                {project.schedule.name}
                                            </Typography>
                                            <Typography sx={{ color: '#8C8C8C', fontSize: '13px', fontWeight: '400', fontFamily: 'Manrope' }}>
                                                {project.schedule.type}
                                            </Typography>
                                        </Box>

                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            {project.memberImgList.slice(0, 3).map((img, i) => (
                                                <Box key={i} sx={{ marginLeft: i === 0 ? '0px' : '-10px' }}>
                                                    <img
                                                        src={img}
                                                        alt={`member-${i}`}
                                                        style={{ width: '34px', height: '34px', borderRadius: '40px' }}
                                                    />
                                                </Box>
                                            ))}

                                            {project.memberImgList.length > 3 && (
                                                <Box
                                                    sx={{
                                                        background: '#EAF0FF',
                                                        width: '34px',
                                                        height: '34px',
                                                        borderRadius: '40px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginLeft: '-10px',
                                                    }}
                                                >
                                                    <Typography sx={{ color: '#7B7E8B', fontSize: '14px', fontWeight: '600' }}>
                                                        +{project.memberImgList.length - 3}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Button variant="contained" sx={{ backgroundColor: statusCodes(project.statusBtn), color: '#fff', textTransform: 'capitalize' }}>
                                            {
                                                project.statusBtn
                                            }
                                        </Button>
                                        <Typography sx={{ color: '#8C8C8C', fontWeight: '400', fontSize: '12px', marginTop: '4px' }}>{project.startDate}</Typography>
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <FormControl fullWidth>
                                            <Select sx={{ width: '140px', height: '40px', borderRadius: '40px', fontSize: '12px' }}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                displayEmpty
                                                value={dropdownOptions[index] || ''}
                                                onChange={(e) =>
                                                    setDropdownOptions(prev => ({
                                                        ...prev,
                                                        [index]: e.target.value,
                                                    }))
                                                }
                                                renderValue={(select) => {
                                                    if (!select) {
                                                        return <Typography sx={{ fontSize: '15px' }}>Action</Typography>
                                                    }
                                                    else {
                                                        return <Typography sx={{ fontSize: '13px' }}>{select}</Typography>
                                                    }
                                                }}
                                            >
                                                {
                                                    project.options.map((item, i) => (
                                                        <MenuItem key={i} value={item} sx={{ fontSize: '15px' }}>
                                                            {item}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
export default Data
